<template>
  <label :for="fieldId" :class="{'sr-only': label.hidden}">
    <span
        v-text="labelValue"
    />
    <span v-if="validator && validator.required" class="required">*</span>
  </label>
</template>

<script>
export default {
  props: {
    fieldId: null,
    label: Object,
    validator: {},
    product:  {}
  },
  methods: {
      toCurrency(value) {
          if (typeof value !== "number") {
              return value;
          }
          var formatter = new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: 'USD',
              minimumFractionDigits: 2
          });
          return formatter.format(value);
      }
  },
  computed: {
      labelValue() {
          let label = this.label.value;
          if (this.product.price) {
              let price = parseFloat(this.product.price);
              if (isNaN(price)) {
                  price = this.product.price;
              }
              label += ' - ' + this.toCurrency(price);
          }
          return label;
      }
  }
};
</script>
